export const getCustomer = (state) => state.customers.customer;

export const getIsNewCustomer = (state) => state.customers.customer.id == null;
